import Dialog from '@/components/dataDisplay/Dialog';
import Button from '@/components/input/Button';
import Input from '@/components/input/Input';
import theme from '@/constants/theme';
import { adminResetPassword } from '@/services/authService';
import { Edit } from '@mui/icons-material';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';

interface Props {
  id: string;
  email: string;
}

const UserListOptions: React.FC<Props> = ({ id, email }) => {
  const [visible, setVisible] = useState(false);
  const [newPassword, setNewPassword] = useState('');

  const handleChangePassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!newPassword) return;
    adminResetPassword(id, newPassword).then(() => {
      enqueueSnackbar({
        variant: 'success',
        message: 'Contraseña cambiada correctamente',
      });
      setVisible(false);
      setNewPassword('');
    });
  };

  return (
    <>
      <Button variant="ghost" size="small" Icon={Edit} onClick={() => setVisible(true)}>
        Cambiar contraseña
      </Button>
      <Dialog open={visible} setOpen={setVisible}>
        <form
          onSubmit={handleChangePassword}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            width: '500px',
            maxWidth: '100%',
            maxHeight: '100%',
            overflow: 'auto',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <h2>Cambiar la contraseña</h2>
            <p style={{ color: theme.colors.text.caption }}>{email}</p>
          </div>
          <Input
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Nueva contraseña"
          />
          <div style={{ display: 'flex', flexDirection: 'row', gap: 16, justifyContent: 'end' }}>
            <Button variant="danger" type="button" onClick={() => setVisible(false)}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Guardar
            </Button>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default UserListOptions;
